import {
  WHAT_HAPPENED,
  FEELINGS,
  FUNCTIONS,
  SENIORITY,
  TIME_PERIODS,
  REACTIONS,
} from "@/shared/taxonomy";

import type { WhatHappenedId, FeelingId, FunctionId, SeniorityId, TimePeriodId, ReactionId } from "@/shared/taxonomy";
export function getLabel<T extends string>(list: readonly { id: T; label: string; emoji?: string | null }[], id: T): string {
  return list.find((item) => item.id === id)?.label ?? id;
}

export function getEmoji<T extends string>(list: readonly { id: T; label: string; emoji?: string | null }[], id: T): string | null {
  return list.find((item) => item.id === id)?.emoji ?? null;
}

export function formatWhatHappened(ids: WhatHappenedId[] | undefined | null): string {
  return (ids ?? []).map((id) => getLabel(WHAT_HAPPENED, id)).join(" · ");
}

export function formatFeelings(ids: FeelingId[] | undefined | null): string {
  return (ids ?? []).map((id) => {
    const emoji = getEmoji(FEELINGS, id);
    const label = getLabel(FEELINGS, id);
    return emoji ? `${emoji} ${label}` : label;
  }).join(", ");
}

export function formatFunction(id: FunctionId | null): string | null {
  return id ? getLabel(FUNCTIONS, id) : null;
}

export function formatSeniority(id: SeniorityId | null): string | null {
  return id ? getLabel(SENIORITY, id) : null;
}

export function formatCity(id: string | null): string | null {
  return id ? id.replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase()) : null;
}

export function formatTimePeriod(id: TimePeriodId | null): string | null {
  return id ? getLabel(TIME_PERIODS, id) : null;
}

export function getWhatHappenedAccentColor(ids: WhatHappenedId[] | undefined | null): string {
  if (!ids || ids.length === 0) return "#7c3aed";
  const first = WHAT_HAPPENED.find((w) => w.id === ids[0]);
  return first?.accentColor ?? "#7c3aed";
}

export function getReactionEmoji(id: ReactionId): string {
  return getEmoji(REACTIONS, id) ?? "❓";
}

export function getReactionLabel(id: ReactionId): string {
  return getLabel(REACTIONS, id);
}
